import { Select } from "src/components/shared/MantineCombobox";
import { useCallback, useRef } from "react";
import { useFormContext } from "react-hook-form";

import { useInputProps } from "../../hooks/useInputProps";
import { getMatchedFieldId, getMatchedValue } from "./ClickInput.utils";

interface Props {
  id: string;
  value: string;
  required: boolean;
  unit: string;
  width: string;
}

const ClickPopulateSelect = ({ id, value, required, unit, width }: Props) => {
  const {
    ref: addToRefs,
    onChange: defaultOnChange,
    ...inputProps
  } = useInputProps(id, value, required);
  const { setValue } = useFormContext();

  const selectRef = useRef<HTMLInputElement | null>(null);

  const handleChange = useCallback(
    (value: string) => {
      defaultOnChange(value);
      if (selectRef.current) {
        const matchedFieldId = getMatchedFieldId(selectRef.current, unit, true);
        const matchedValue = getMatchedValue(value);
        if (matchedFieldId && matchedValue) {
          setValue(matchedFieldId, matchedValue);
        }
      }
    },
    [defaultOnChange, setValue, unit],
  );

  const getSelectData = useCallback(() => {
    const yachtdata = JSON.parse(localStorage.getItem("yachtData") ?? "");
    const yachtValue = yachtdata?.gmdss ? yachtdata.gmdss[unit] : "";
    const data = [yachtValue];

    const letters = Array.from({ length: 26 }, (_, i) =>
      String.fromCharCode(65 + i),
    );
    letters.forEach(letter => {
      if (yachtdata.gmdss[`${unit}${letter}`]) {
        data.push(yachtdata.gmdss[`${unit}${letter}`]);
      }
    });
    const v = typeof value === "string" ? value : (value?.value ?? "");

    if (v && !data.includes(v)) data.push(v);
    return data;
  }, [unit, value]);

  return (
    <Select
      miw={width ? Number(width) * 10 : 150}
      data={getSelectData()}
      dropdownPosition="top"
      withinPortal={true}
      zIndex={1000}
      ref={ref => {
        selectRef.current = ref;
        addToRefs(ref);
      }}
      onChange={handleChange}
      {...inputProps}
    />
  );
};

export default ClickPopulateSelect;
